<template>
  <section id="features" class="py-24 bg-gray-50">
    <div class="max-w-7xl mx-auto px-6">
      <div class="text-center mb-16">
        <h2 class="text-3xl md:text-4xl font-bold mb-4">為什麼選擇快樂買？</h2>
        <p class="text-gray-500">不僅僅是購物車，更是您的全方位銷售夥伴</p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-10">
        <!-- Feature 1 -->
        <div
          class="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-lg transition-shadow reveal"
        >
          <div
            class="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600 mb-6"
          >
            <svg
              class="w-7 h-7"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 10V3L4 14h7v7l9-11h-7z"
              ></path>
            </svg>
          </div>
          <h3 class="text-xl font-bold mb-3">一頁式極速結帳</h3>
          <p class="text-gray-500 leading-relaxed text-sm">
            整合商品展示、購物車與結帳表單於同一頁面。支援分步驟
            填寫，大幅降低跳出率，提升成交可能。
          </p>
        </div>

        <!-- Feature 2: Multiple Landing Pages (更新後) -->
        <div
          class="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-lg transition-shadow reveal"
        >
          <div
            class="w-14 h-14 bg-purple-50 rounded-xl flex items-center justify-center text-purple-600 mb-6"
          >
            <!-- Icon: Layers / Multiple Pages -->
            <svg
              class="w-7 h-7"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
              ></path>
            </svg>
          </div>
          <h3 class="text-xl font-bold mb-3">彈性開設多組銷售頁</h3>
          <p class="text-gray-500 leading-relaxed text-sm">
            不再受限於單一官網架構。您可以針對不同商品、節慶活動或廣告受眾，快速生成無限量的獨立銷售頁面，精準承接流量，提升轉單率。
          </p>
        </div>

        <!-- Feature 3 -->
        <div
          class="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-lg transition-shadow reveal"
        >
          <div
            class="w-14 h-14 bg-amber-50 rounded-xl flex items-center justify-center text-amber-600 mb-6"
          >
            <svg
              class="w-7 h-7"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
          </div>
          <h3 class="text-xl font-bold mb-3">多元的金流串接</h3>
          <p class="text-gray-500 leading-relaxed text-sm">
            支援綠界、藍新、PCHome支付鏈等多家金流服務。並提供信用卡、ATM轉帳、LINE
            PAY與無卡分期等多種付款方式，滿足不同客群需求。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FeatureSection",
};
</script>
